import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InternalError extends Component {
    static defaultProps = {
        errorMessageTechnical: '',
    };

    static propTypes = {
        errorMessage: PropTypes.string.isRequired,
        errorMessageTechnical: PropTypes.string,
        supportEmail: PropTypes.string.isRequired,
    };

    /**
     * @returns {React.ReactNode}
     */
    render() {
        const { errorMessage, errorMessageTechnical, supportEmail } = this.props;
        const mailToSupport = `mailto:${supportEmail}`
            + `?subject=${encodeURIComponent(errorMessage)}`
            + `&body=${encodeURIComponent(errorMessageTechnical)}`;
        return (
            <div style={{ margin: '45px auto', width: '500px' }}>
                <h5>
                    {'Internal error occurred: '}
                    {String(errorMessage).toLocaleLowerCase()}
                </h5>
                <ol>
                    <li>Try to refresh page</li>
                    <li>
                        {'If problem continues to appear contact '}
                        <a href={mailToSupport}>Tech Support</a>
                    </li>
                </ol>
            </div>
        );
    }
}

export default InternalError;
